<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [searchText]="searchText"
   [hasSearchInput]="true"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   [pluralNameOverride]="name"
>
   <ndt-register-quick-filter>
      <ndt-call-history-filter
         [quickFilters]="registerOptions"
         [isOnCallHistoryPage]="true"
         (logQuickFilterChanged)="onFilterChange($event)"
         [isSystemUser]="isSystemUser"
      ></ndt-call-history-filter>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="callDirection" [width]="2.75">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="callDirection-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callDirectionTypeId')"
               sortField="callDirectionTypeId"
               >Direction <mat-icon class="mat-icon-sort">{{ getSort('callDirectionTypeId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.callDirection | addSpaces }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callSource" [width]="7.5">
            <th lcs-header-cell *lcsHeaderCellDef id="from-column-header">From</th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.callSource | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDestination" [width]="7.5">
            <th lcs-header-cell *lcsHeaderCellDef id="to-column-header">To</th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.callDestination | formatPhoneNumbers }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="destinationNumber" [width]="3">
            <th lcs-header-cell *lcsHeaderCellDef id="destination-number-column-header">Dialed</th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{
                     (activeCalls.callDirectionTypeId == 'Inbound' && activeCalls.phoneNumber
                        ? activeCalls.phoneNumber
                        : activeCalls.originalDestinationNumber
                     ) | formatPhoneNumbers
                  }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDuration" [width]="2.5">
            <th class="header-align-right" lcs-header-cell *lcsHeaderCellDef id="duration-column-header">Duration</th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a class="text-align-right" (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.startTime | durationFormat : activeCalls.endTime }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="startTime" [width]="4.25">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="call-date-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'startTime')"
               sortField="startTime"
               >Date/Time <mat-icon class="mat-icon-sort">{{ getSort('startTime') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ activeCalls.startTime | date : 'MM/dd/yyyy hh:mm aa' }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="callDispositionTypeId" [width]="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="call-disposition-type-id-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'callDispositionTypeId')"
               sortField="callDispositionTypeId"
               >Disposition <mat-icon class="mat-icon-sort">{{ getSort('callDispositionTypeId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{
                     activeCalls.callDispositionTypeId === 'QueueCallBack'
                        ? 'Callback'
                        : activeCalls.callDispositionTypeId
                  }}
               </a>
            </td>
         </ng-container>
         @if (isSystemUser) {
         <ng-container lcsColumnDef="sourceProvider" width="3.75">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="source-provider-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'sourceProviderId')"
               sortField="sourceProviderId"
               >Source Provider<mat-icon class="mat-icon-sort">{{ getSort('sourceProviderId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ formatProvider(activeCalls.sourceProviderId) }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="destinationProvider" width="3.5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="destination-provider-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'destinationProviderId')"
               sortField="destinationProviderId"
               >Dest. Provider <mat-icon class="mat-icon-sort">{{ getSort('destinationProviderId') }}</mat-icon></th
            >
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <a (click)="onOpenDialog(activeCalls)">
                  {{ formatProvider(activeCalls.destinationProviderId) }}
               </a>
            </td>
         </ng-container>
         }
         <ng-container lcsColumnDef="callHistoryActionsMenu" [width]="0.75">
            <th lcs-header-cell *lcsHeaderCellDef id="call-history-actions-menu-column-header"></th>
            <td
               lcs-cell
               *lcsCellDef="let activeCalls"
               [ngClass]="{ highlighted: activeCalls?.callRate > 0 && isSystemUser }"
            >
               <button
                  type="button"
                  aria-label="Call History Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="callHistoryMenu"
                  [matMenuTriggerData]="{ $implicit: promptItem, index: promptArrayIndex }"
                  [disabled]="disabled"
                  id="device-detail-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #callHistoryMenu="matMenu">
                  <button mat-menu-item type="button" id="call-history-details" (click)="onOpenDialog(activeCalls)">
                     Details
                  </button>
                  @if ( activeCalls?.callRecordingId && activeCalls.startTime >= hideRecordingDate && (!isSystemUser ||
                  callRecordingsPrivileges?.enabled || callRecordingsLCSPrivileges?.enabled) &&
                  activeCalls?.callRecordingFile && !activeCalls.isPhoneCallThatWentDirectlyToSourceExtension ) {
                  <button mat-menu-item type="button" id="call-history-details" (click)="onListen(activeCalls)">
                     Listen
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
   <mat-menu #callHistoryMenu="matMenu">
      <button mat-menu-item type="button" id="call-history-details"> Details </button>
   </mat-menu>
</ndt-register-view>
